/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.settings.fields.controllers', [
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.permissions',
  'acme.common.factory.notice',
  'acme.view.application.settings.modals.fields.controllers',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.common.service.templates'
])

.controller('SettingsFieldsController', ['$scope', '$uibModal', '$timeout', '$state', 'ApiService', 'NoticeFactory', 'GridStateFactory', 'GridDefinitionFactory', 'PermissionsService', 'TemplatesService', function($scope, $uibModal, $timeout, $state, ApiService, NoticeFactory, GridStateFactory, GridDefinitionFactory, PermissionsService, TemplatesService) {

    $scope.settingsFields = {

      model: [],
      selected: '',

      search: '',
      searchQuery: '',
      max: {
        events: 5,
        donations: 20,
        forms: 20
      },
      viewId: '',
      tab: 'events',
      services: {
        events: '',
        forms: 'form',
        donations: 'donations'
      },

      service: '',

      gridName: $state.current.name+'.grid0',

      gridState: new GridStateFactory(),
      gridDefinition: new GridDefinitionFactory(),

      isLoaded: false,
      errorResponse: {
        data:  {
          error: 'Something went wrong. Please try again later.'
        }
      },

      optionsOverride: {
        data: 'settingsFields.model',
        rowHeight: 40,
        appScopeProvider: {
          onDataGridSortChange: function(grid, columns) {
            $scope.settingsFields.onDataGridSortChange(grid, columns);
          },
          onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
            $scope.settingsFields.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
          },
          onDblClick: function(row) {
            if (PermissionsService.check('CUSTOM_FIELDS_UPDATE')) {
              $scope.settingsFields.open(true, row);
            }
          },
          edit: function(row) {
            $scope.settingsFields.open(true, row);
          }
        },
        columnDefs: [
          {
            field: 'id',
            displayName: 'ID',
            visible: false,
            width: 50
          },
          {
            field: 'name',
            displayName: 'Name',
            visible: false,
            width: 150
          },{
            field: 'ndx',
            displayName: 'Number',
            visible: true,
            width: 100,
            sort: {
              direction: 'asc'
            }
          },
          {
            field: 'reportFieldName',
            displayName: 'Reporting field name',
            visible: true,
            width: 150
          },
          {
            field: 'label',
            displayName: 'Label',
            visible: true,
            width: 150
          },
          {
            field: 'format',
            displayName: 'Format',
            visible: true,
            width: 100
          },
          {
            field: 'values',
            displayName: 'Values',
            cellTemplate: '<div class="ui-grid-cell-contents" data-ng-class="col.colIndex()"><span data-ng-show="row.entity.format ===  \'Text\' " style="color: #a3a3a3">Not applicable</span><span data-ng-show="row.entity.format ===  \'Dropdown\'  " class="name" data-ng-repeat="value in row.entity.values">{{ value }} {{ $last ? "" : ", "  }}</span></div>',
            cellRenderer: function (param) {
              var pref, suf, r = '';
              
              if(param.node.data.format === "Dropdown") {
                pref = '<div class="ui-grid-cell-contents" data-ng-class="col.colIndex()"><div class="name">';
                suf = '</div></div>';
                r = pref + param.value.join(', ') + suf;                 
              } else if(param.node.data.format === "Text") {
                pref = '<div class="ui-grid-cell-contents" data-ng-class="col.colIndex()"><div style="color:#a3a3a3">';
                suf = '</div></div>';
                r = pref + 'Not applicable' + suf;
              }
              
              return r;
 
            },
            visible: true
          },
          {
            field: 'saleChannelsSupported[0].enabled',
            displayName: 'Web',
            cellTemplate: '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>',
            cellRenderer: function(param) {
              var r = '';

              if ((param.node.data.saleChannelsSupported instanceof Array) && param.node.data.saleChannelsSupported[0].enabled) {
                r = 'Yes';
              } else {
                r = 'No';
              }
              return r;
            },
            visible: false
          },
          {
            field: 'saleChannelsSupported[1].enabled',
            displayName: 'POS',
            cellTemplate: '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell">{{COL_FIELD}}<span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>',
            cellRenderer: function(param) {
              var r = '';

              if ((param.node.data.saleChannelsSupported instanceof Array) && param.node.data.saleChannelsSupported[1].enabled) {
                r = 'Yes';
              } else {
                r = 'No';
              }
              return r;
            },
            visible: false
          },
          {
            field: 'saleChannelsSupported[2].enabled',
            displayName: 'Reseller',
            cellTemplate: '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell">{{COL_FIELD}}<span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>',
            cellRenderer: function(param) {
              var r = '';

              if ((param.node.data.saleChannelsSupported instanceof Array) && param.node.data.saleChannelsSupported[2].enabled) {
                r = 'Yes';
              } else {
                r = 'No';
              }
              return r;
            },
            visible: false
          },
          {
            field: 'saleChannelsSupported[3].enabled',
            displayName: 'Customer Rep.',
            cellTemplate: '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell">{{COL_FIELD}}<span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>',
            cellRenderer: function(param) {
              var r = '';

              if ((param.node.data.saleChannelsSupported instanceof Array) && param.node.data.saleChannelsSupported[3].enabled) {
                r = 'Yes';
              } else {
                r = 'No';
              }
              return r;
            },
            visible: false
          }
        ]
      },

      notice: new NoticeFactory(),

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Custom Fields',
          buttonRight: {
            label: 'Add Field',
            permissions: 'CUSTOM_FIELDS_CREATE',
            action: function () {
              $scope.settingsFields.open(false);
            }
          }
        });

        if (PermissionsService.check('CUSTOM_FIELDS_UPDATE')) {
          this.optionsOverride.columnDefs.unshift({
            field: 'edit',
            displayName: 'Edit',
            headerTooltip: true,
            width: 50,
            onCellNavClick: function(row, col) {
              $scope.settingsFields.optionsOverride.appScopeProvider.edit(row);
            },
            cellTemplate: '<div class="clickable ui-grid-cell-contents" title="EDIT"><a data-ng-click="grid.appScope.edit(row)" role="link">Edit<span class="sr-only"> Details for {{ row.entity.label }}</span></a></div>',
            visible: true,
            enableHiding: false,
            enableSorting: false,
            suppressSizeToFit: true
          });
        }
        
        this.viewId = $state.current.name;
        
        this.gridDefinition.init(this.gridName, this.optionsOverride, this.viewId, $state.current.data.enablePreferences);

        $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);

      },
      
      initData: function(e, data) {
        var self = $scope.settingsFields, props = self.gridDefinition.getGridState();
        self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
        self.getCustomFields();
      },

      changeColumnVisibility: function() {
        if (this.isTab('events')) {
          this.gridDefinition.setColumnVisibility({
            'ndx': true,
            'name': false,
            'reportFieldName': false
          });
        } else {
          this.gridDefinition.setColumnVisibility({
            'ndx': false,
            'name': true,
            'reportFieldName': true
          });
        }
      },

      getCustomFields: function() {

        this.notice.hideErrorMessages();
        this.notice.hideSuccessMessages();

        if (this.service) {
          if (!!ApiService[this.service]) {
            ApiService[this.service].customFields.list(this.gridState.getGridState()).then(this.success.getCustomFields, this.error.getCustomFields);
          } else {
            this.error.getCustomFields(this.errorResponse);
          }
        } else {
          ApiService.customFields.list(this.gridState.getGridState()).then(this.success.getCustomFields, this.error.getCustomFields);
        }

      },

      isMaxed: function() {
        return (this.model.length >= this.max[this.tab]);
      },

      checkMaxed: function() {
        if (this.isMaxed()) {
          $scope.$emit('Application::contentTitleChange', {
            title: 'Custom Fields'
          });
        } else {
          $scope.$emit('Application::contentTitleChange', {
            title: 'Custom Fields',
            buttonRight: {
              label: 'Add Field',
              permissions: 'CUSTOM_FIELDS_CREATE',
              action: function () {
                $scope.settingsFields.open(false);
              }
            }
          });
        }
      },

      isTab: function(tab) {
        return (tab && this.tab === tab);
      },

      getTab: function(tab) {
        if (this.tab !== tab) {
          this.tab = tab;

          this.service = this.services[this.tab];

          $timeout(function() {
            var self = $scope.settingsFields;

            $scope.$broadcast('DataGrid::ResetCaret');
            $scope.$broadcast('DataGrid::Search', {
              name: self.gridName
            });

          }, 10);
        }
      },

      processSalesChannels: function(list) {
        var i, ii,
            j, jj,
            salesChannels;

        for (i=0,ii=list.length;i<ii;i++) {

          salesChannels = TemplatesService.salesChannels;

          if (list[i].saleChannelsSupported instanceof Array) {
            for (j=0, jj=salesChannels.length; j < jj; j++) {
              if (list[i].saleChannelsSupported.indexOf(salesChannels[j].channel) > -1) {
                salesChannels[j].enabled = true;
              } else {
                salesChannels[j].enabled = false;
              }
            }
          }
          list[i].saleChannelsSupported = angular.copy(salesChannels);
          list[i].saleChannelsSupported = TemplatesService.orderSalesChannels(list[i].saleChannelsSupported);
        }

        return list;
      },

      open: function(editMode, row) {
        var self = $scope.settingsFields;
        
        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/settings/modals/fields/fields.tpl.html',
          size: self.isTab('events') ? 'md' : 'lg',
          controller: 'SettingsModalsFieldsController',
          resolve: {
            field: function() {
              return (editMode) ? row.entity : false;
            },
            customFieldType: function() {
              return self.tab;
            },
            existingCustomFieldNames: function() {
              return self.model.map(function(customField) {
                return customField.name;
              });
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (customField) {
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();
          if (editMode) {
            self.update(customField);
          } else {
            self.create(customField);
          }
        }, function () {
          // Do nothing
        });

      },

      update: function(customField) {
        var success = function () {
          var self = $scope.settingsFields;

          self.showSuccessMessage('Successfully updated field');
          self.getCustomFields();

        };

        if (this.service) {
          if (!!ApiService[this.service]) {
            ApiService[this.service].customFields.update(customField).then(success, this.error.update);
          } else {
            this.error.update(this.errorResponse);
          }
        } else {
          ApiService.customFields.update(customField).then(success, this.error.update);
        }
      },

      create: function(customField) {
        var success = function () {
          var self = $scope.settingsFields;

          self.showSuccessMessage('Successfully added field');
          self.getCustomFields();

        };

        if (this.service) {
          if (!!ApiService[this.service]) {
            ApiService[this.service].customFields.create(customField).then(success, this.error.create);
          } else {
            this.error.create(this.errorResponse);
          }
        } else {
          ApiService.customFields.create(customField).then(success, this.error.create);
        }

      },

      hasData: function() {
        return (this.model instanceof Array && this.model.length > 0);
      },
      
      showSuccessMessage: function (msg) {
        var self = $scope.settingsFields;
        self.notice.showSuccessMessages([{
          message: msg
        }]);
        $timeout(function() {
          self.notice.hideSuccessMessages();
        }, 3000);
      },

      success: {
        getCustomFields: function(response) {
          var self = $scope.settingsFields;
          if (!self.isTab('events')) {
            self.model = self.processSalesChannels(response.data.payload.list);
          } else {
            self.model = response.data.payload.list;
          }
          self.checkMaxed();
          if (!$scope.$$phase) {
            $scope.$apply();
          }
          self.isLoaded = true;
          self.gridDefinition.isLoaded = true;

          self.changeColumnVisibility();
          // Next tick
          $timeout(function() {
            $scope.$broadcast('DataGrid::ResizeGrid', {name: self.gridDefinition.options.gridName, datasetLength: self.model.length, totalItems: response.data.payload.pagination.count});
          }, 10);
        }
       },
      error: {
        getCustomFields: function(response) {
          var self = $scope.settingsFields;
          self.notice.showErrorMessages([{
            message: response.data.error
          }]);
          self.model = [];
          // Next tick
          $timeout(function() {
            $scope.$broadcast('DataGrid::ResizeGrid', {name: self.gridDefinition.options.gridName, datasetLength: self.model.length, totalItems: 0});
          }, 10);
        },
        create: function(response) {
          var self = $scope.settingsFields;
          self.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },
        update: function(response) {
          var self = $scope.settingsFields;
          self.notice.showErrorMessages([{
            message: response.data.error
          }]);
        }
      },

      gridDoubleClick: function() {},

      onDataGridPaginate: function(newPage, pageSize, sortField, sortDirection) {
        var self = $scope.settingsFields,
          data = {
          currentPage: newPage || 1,
          pageSize: pageSize || this.gridDefinition.options.paginationPageSize
        };

        self.gridState.updateGridState(data.currentPage, data.pageSize);
        if (sortField) {
          self.gridState.updateGridState(null, null, sortField, null);
        }
        if(sortDirection) {
          self.gridState.updateGridState(null, null, null, sortDirection);
        }
        self.getCustomFields();
      },

      onDataGridSortChange: function(grid, columns) {
        var self = $scope.settingsFields, data = columns[0];
        if(data) {
          self.gridState.updateGridState(null, null, data.field, data.sort.direction);
          self.getCustomFields();
        }
      }      
      
    };

    $scope.settingsFields.init();

}]);